/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putNotificationPreferences.defs'
export { main as default } from './putNotificationPreferences.defs'
